{
  "name": "plowops-dashboard",
  "version": "3.10.10",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-local": "ng serve --configuration local",
    "start-localtotest": "ng serve --configuration localtotest",
    "start-localtodev": "ng serve --configuration localtodev",
    "build": "ng build --configuration prod --base-href /dashboard/",
    "build-local": "ng build --configuration local",
    "build-dev": "ng build --configuration dev --base-href /",
    "build-test": "ng build --configuration test --base-href /",
    "build-prod": "ng build --configuration prod --base-href /",
    "watch": "ng build --watch --configuration dev",
    "format": "prettier --write \"src/**/*.{ts,html,css,scss,json}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,css,scss,json}\"",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix"
  },
  "private": true,
  "dependencies": {
    "@ali-hm/angular-tree-component": "^20.3.4",
    "@angular/animations": "^20.3.24",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.24",
    "@angular/compiler": "^20.3.24",
    "@angular/core": "^20.3.24",
    "@angular/forms": "^20.3.24",
    "@angular/material": "^20.2.14",
    "@angular/material-moment-adapter": "^20.2.14",
    "@angular/platform-browser": "^20.3.24",
    "@angular/platform-browser-dynamic": "^20.3.24",
    "@angular/router": "^20.3.24",
    "@arcgis/core": "^4.34.8",
    "@aws-amplify/ui-angular": "^5.3.3",
    "@esri/arcgis-rest-geocoding": "^4.10.2",
    "@ngrx/store": "^20.1.0",
    "@ngrx/store-devtools": "^20.1.0",
    "@sentry/angular": "^10.47.0",
    "@types/geojson": "^7946.0.16",
    "@types/sockjs-client": "^1.5.4",
    "@warren-bank/node-sortedlist": "^1.0.5",
    "angular-google-tag-manager": "1.12.0",
    "aws-amplify": "^6.16.3",
    "echarts": "^6.0.0",
    "file-saver-es": "^2.0.5",
    "geobuf": "^4.0.0",
    "hls.js": "^1.6.15",
    "maplibre-gl": "^5.24.0",
    "pmtiles": "^4.4.1",
    "moment": "^2.30.1",
    "ngx-color-picker": "^20.1.1",
    "ngx-colors": "^3.6.0",
    "ngx-echarts": "^20.0.2",
    "ngx-markdown": "^20.1.0",
    "quill": "^2.0.3",
    "rxjs": "~7.8.2",
    "shpjs": "^6.2.0",
    "suncalc": "^1.9.0",
    "pako": "^2.1.0",
    "tslib": "^2.8.1",
    "turndown": "^7.2.2",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-builders/custom-webpack": "^20.0.0",
    "@angular-devkit/schematics": "^20.3.27",
    "@angular-eslint/builder": "^20.7.0",
    "@angular-eslint/eslint-plugin": "^20.7.0",
    "@angular-eslint/eslint-plugin-template": "^20.7.0",
    "@angular-eslint/schematics": "^20.7.0",
    "@angular-eslint/template-parser": "^20.7.0",
    "@angular/build": "^20.3.27",
    "@angular/cli": "^20.3.27",
    "@angular/compiler-cli": "^20.3.24",
    "@angular/language-service": "^20.3.24",
    "@schematics/angular": "^20.3.23",
    "@sentry/esbuild-plugin": "^4.9.1",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~3.10.18",
    "@types/node": "^20.19.23",
    "@typescript-eslint/eslint-plugin": "^8.58.1",
    "@typescript-eslint/parser": "^8.58.1",
    "eslint": "^9.39.4",
    "eslint-config-prettier": "^10.1.8",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~4.0.2",
    "karma-jasmine-html-reporter": "^1.7.0",
    "prettier": "^3.8.1",
    "typescript": "~5.9.3"
  },
  "overrides": {}
}
